<template>
  <div id="footer">
    <router-link to="/" class="footer_item" :class="active == 0? 'active' :''">
      <div class="icon_wrap">
        <van-icon name="wap-home-o" class="ft_icon"/>
      </div>
      <p class="footer_info">Inicio</p>
    </router-link>
    <router-link to="/share" class="footer_item" :class="active == 1? 'active' :''">
      <div class="icon_wrap">
        <van-icon name="point-gift-o" class="ft_icon"/>
      </div>
      <p class="footer_info">Promoção</p>
    </router-link>
    <router-link to="/recharge" class="footer_item" :class="active == 2? 'active' :''">
      <div class="icon_wrap">
        <van-icon name="card" class="ft_icon" />
      </div>
      <p class="footer_info">Fundos</p>
    </router-link>
    <router-link to="/support" class="footer_item" :class="active == 3? 'active' :''">
      <div class="icon_wrap">
        <van-icon name="service" class="ft_icon"/>
      </div>
      <p class="footer_info">Suporte</p>
    </router-link>
    <router-link to="/person" class="footer_item" :class="active == 4? 'active' :''">
      <div class="icon_wrap">
        <van-icon name="manager-o" class="ft_icon"/>
      </div>
      <p class="footer_info">Perfil</p>
    </router-link>
  </div>
</template>
<script>
export default {

  props: {
    active: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {

    };
  },
  created() {
    // console.log(this.active)
  },

};
</script>
<style lang="less" scoped>
#footer {
  position: fixed;
  height: 1.6rem;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background: rgb(36, 36, 36);
  color: #777777;
}

.footer_item {
  display: flex;
  width: 25%;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 0.3rem 0;
}

.icon_wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.ft_icon {
  font-size: 0.667rem;
  color: #777777
}

.footer_info {
  color: #777777;
  margin-top: 0.1rem;
}
.active .ft_icon{
  color: #feb705
}
.active .footer_info{
  color: #feb705
}
</style>